import type { OrderDetails } from '@/entities/order/model'
import { Group, Paper, Stack, Text } from '@mantine/core'
import { OrderStatusDisplay } from '@/entities/order/ui'
import { getOrderSecondaryMessage, getRestrictedItemsDisplay, hasRestrictedField, useOrderAlert, usePanelOrderStatus } from '@/features/order/lib'
import { formatTime } from '@/shared/lib/dayjs'
import { HsFieldsTable } from '../hs-fields-table/HsFieldsTable'
import classes from './OrderDetailsMobileLayout.module.css'

interface OrderDetailsMobileLayoutProps {
  order: OrderDetails
  withoutBackdrop?: boolean
}

export function OrderDetailsMobileLayout({ order, withoutBackdrop }: OrderDetailsMobileLayoutProps) {
  const { displayState } = useOrderAlert(order)
  const { statusText, statusDisplayState, isPanelOrderContext } = usePanelOrderStatus({
    order,
    displayState,
    withoutBackdrop,
  })

  return (
    <>
      <Paper className={classes.orderInfoCard} radius="md" p="md">
        <Group justify="space-between" align="flex-start">
          <Stack gap="4px">
            <Text span className={classes.orderNumberLabel}>Order number</Text>
            <Text span className={classes.orderNumberValue}>{order.orderId}</Text>
          </Stack>
          <OrderStatusDisplay
            orderStatus={statusText}
            displayState={statusDisplayState}
            secondaryText={isPanelOrderContext ? undefined : getOrderSecondaryMessage(
              order.status,
              order.lastTransitionTime ? formatTime(order.lastTransitionTime, 'HH:mm') : undefined,
            )}
            eta={order.eta}
            etaDirection={order.etaDirection}
            scheduledTimeForCollection={order.scheduledTimeForCollection}
          />
        </Group>
      </Paper>

      <HsFieldsTable hsFields={order.hsFields} variant="mobile" />

      {hasRestrictedField(order) && (
        <Paper className={classes.modalCard} mb="md">
          <Text span className={classes.modalCardLabel}>Restricted items</Text>
          <Text span className={classes.modalCardValue}>{getRestrictedItemsDisplay(order.hsFields)}</Text>
        </Paper>
      )}
    </>
  )
}
